<template>
  <div>
    <h6 class="text-left">
      {{ 'latest_orders' | i18n }}
    </h6>
    <div style="overflow-x: scroll">
      <b-table :items="items" :fields="fields" :show-empty="true" :empty-text="noTableDataTitle" :empty-filtered-text="noTableDataTitle" :busy="busy">
        <template #cell(createdDate)="row">
          {{ row.item.createdDate | formatUnixDate('DD.MM.YY HH:mm') }}
        </template>
        <template #cell(orderSumNumeric)="row">
          {{ row.item.orderSumNumeric | formatPrice }}
        </template>
        <template #cell(details)="row">
          <router-link v-b-tooltip.hover :to="`/order/${row.item.id}`" class="row-details-btn" :title="'edit' | i18n">
            <BIconPencilSquare />
          </router-link>
        </template>
      </b-table>
    </div>
    <router-link to="orders" class="float-right" style="margin: 10px 0">
      {{ 'to_order_intake' | i18n }}
      <BIconArrowRight />
    </router-link>
  </div>
</template>

<script>
import { BTable, BIconPencilSquare, BIconArrowRight } from 'bootstrap-vue';
import { NO_TABLE_DATA_TITLE } from '../../../../../../../constants';

export default {
  name: 'LatestOrders',
  components: { BTable, BIconPencilSquare, BIconArrowRight },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      fields: [
        { key: 'orderDefaultNumber', label: this.$translate('number_short') },
        { key: 'customerNumber', label: this.$translate('customer_number') },
        { key: 'name1', label: this.$translate('name1') },
        { key: 'orderSumNumeric', label: this.$translate('sum') },
        { key: 'currency', label: this.$translate('currency') },
        { key: 'createdDate', label: this.$translate('created_date') },
        { key: 'details', label: '' },
      ],
      noTableDataTitle: this.$translate(NO_TABLE_DATA_TITLE),
    };
  },
};
</script>
